const CHECKOUT_STORAGE_KEY = 'chefmargaro_checkout';

export function loadCheckoutState() {
  try {
    const raw = localStorage.getItem(CHECKOUT_STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function saveCheckoutState(state) {
  try {
    localStorage.setItem(CHECKOUT_STORAGE_KEY, JSON.stringify(state));
  } catch {
    // ignore quota / private mode errors
  }
}

export function clearCheckoutState() {
  try {
    localStorage.removeItem(CHECKOUT_STORAGE_KEY);
  } catch {
    // ignore
  }
}

/** La cotización del mapa no se persiste: tras recargar hay que volver a elegir dirección. */
export function sanitizeDeliveryDataForStorage(deliveryData) {
  if (!deliveryData) {
    return deliveryData;
  }
  return {
    ...deliveryData,
    mapsQuote: null,
    direccion: '',
  };
}

export function parseMapsQuoteFromSearchParams(searchParams) {
  const lat = searchParams.get('lat');
  const lng = searchParams.get('lng');
  const total = searchParams.get('total');

  if (lat == null || lng == null || total == null) {
    return null;
  }

  const latNum = parseFloat(lat);
  const lngNum = parseFloat(lng);
  const deliveryTotal = parseFloat(total);

  if (!Number.isFinite(latNum) || !Number.isFinite(lngNum) || !Number.isFinite(deliveryTotal)) {
    return null;
  }

  return {
    email: searchParams.get('email') || '',
    distance_km: searchParams.get('distance_km') ?? '',
    radius: searchParams.get('radius') ?? '',
    base_rate: searchParams.get('base_rate') ?? '',
    surcharge: searchParams.get('surcharge') ?? '',
    total: deliveryTotal,
    restriction: searchParams.get('restriction') ?? '',
    lat: latNum,
    lng: lngNum,
  };
}

export function hasMapsReturnParams(searchParams) {
  return (
    searchParams.get('lat') != null &&
    searchParams.get('lng') != null &&
    searchParams.get('total') != null
  );
}
